import { SortModel } from "./sort-model";

export class PageableModel {
    sort: SortModel;
    offset: number;
    pageSize: number;
    pageNumber: number;
    paged: boolean;
    unpaged: boolean;
}